import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { DownloadDeductionsReportsRequest, reportsService } from '@aslanpay/portal-common-lib';

const useDownloadDeductionsReports = ({
  onSuccess,
  onError,
}: UseMutationOptions<unknown, Error, DownloadDeductionsReportsRequest>) => {
  return useMutation<unknown, Error, DownloadDeductionsReportsRequest>(
    ({ ids }: DownloadDeductionsReportsRequest) =>
      reportsService.downloadDeductionsReports({ ids }),
    { onSuccess, onError }
  );
};

export default useDownloadDeductionsReports;
